import { createTheme } from '@fluentui/react';
import { Color } from './Color';

export const getHoverColor = (value: string) => {
  const color = new Color(value);
  if (color.IsDark()) {
    return color.GetLighterHex(0.2);
  }

  return color.GetDarkerHex(0.2);
};

export const getWaffleFocusBorderColor = (value: string) => {
  const color = new Color(value);
  if (color.IsDark()) {
    return '#fff';
  }

  return '#000';
};

export const appTheme = createTheme({
  fonts: {
    tiny: { fontSize: '0.625rem' }, //10px
    xSmall: { fontSize: '0.625rem' }, //10px
    small: { fontSize: '0.75rem' }, //12px
    smallPlus: { fontSize: '0.75rem' }, //12px
    medium: { fontSize: '0.875rem' }, //14px
    mediumPlus: { fontSize: '1rem' }, //16px
    large: { fontSize: '1.125rem' }, //18px
    xLarge: { fontSize: '1.25rem' }, //20px
    xLargePlus: { fontSize: '1.5rem' }, //24px
    xxLarge: { fontSize: '1.75rem' }, //28px
    xxLargePlus: { fontSize: '2rem' }, //32px
    superLarge: { fontSize: '2.625rem' }, //42px
    mega: { fontSize: '4.25rem' } //68px
  }
});

export const themeStyle = {
  width: '100%'
};
